import {
  Button,
  Card,
  Flex,
  Image,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { GeocodingFeature } from '@mapbox/search-js-core';
import { DEFAULT_PROPERTY_IMAGE_URL } from '../../utils/listing.utils';
import { AddOffMarketListingModal } from '../Listings/OffMarketListings/AddOffMarketListing/AddOffMarketListingModal';

export const AddOffMarketListingPrompt = ({
  initialGeocode,
}: {
  initialGeocode: GeocodingFeature | null;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Card background="bg.mainDark" borderRadius="8px" overflow="hidden">
        <Image alt="Off Market Listing" src={DEFAULT_PROPERTY_IMAGE_URL} />
        <Flex direction="column" gap={4} p={4}>
          <Text fontSize="md">
            We couldn’t find any live MLS listings for{' '}
            {initialGeocode?.properties?.name}
          </Text>
          <Flex>
            <Button size="sm" width="100%" onClick={onOpen}>
              Get offer data for property
            </Button>
          </Flex>
        </Flex>
      </Card>
      <AddOffMarketListingModal
        initialGeocode={initialGeocode}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
